import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import withRouter from "../../Components/Common/withRouter";
import {
  Button,
  Col,
  Row,
  Input,
  TabContent,
  TabPane,
  Spinner,
  CardBody,
  Card,
} from "reactstrap";
import { isEmpty } from "lodash";
import { CartItem, Product } from "types";
import { ProductCard } from "./ProductCard";
import productPlaceholder from "../../assets/images/placeholder/product.png";
import { useGetProducts } from "hooks/useProduct";
import { useGetBranches } from "hooks/useBranches";
import { useGetCategories } from "hooks/useCategories";
import { useGetSuppliers } from "hooks/useSuppliers";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "slices";
import {
  addItem,
  clearCart,
  clearCustomerId,
  clearOrderId,
  removeItem,
  setCustomerId,
} from "../../slices/cart/reducer";
import "./pos.css";
import { BaseInput } from "Components/ui";

import CartItems from "views/Checkout/CartItems";
import PaymentForm from "views/Checkout/PaymentForm";
import ConfirmationDetails from "views/Checkout/ConfirmationDetails";
import SimpleBar from "simplebar-react";
// import { useParams } from "react-router-dom";
import { useGetOrderbyId } from "hooks/useOrders";
import { useGetCustomers } from "hooks/useCustomers";
import AddCustomerModal from "views/Customer/AddCustomerModal";

function POSPage() {
  const dispatch = useDispatch<any>();

  const selectedBranchID = useSelector(
    (state: RootState) => state.branch?.currentBranch?.id
  );
  const cart = useSelector((state: RootState) => state.cart.items);
  document.title = "Papermap | POS";
  const orderId = useSelector((state: RootState) => state.cart.order_id);
  // const currentBranch = useSelector(
  //   (state: RootState) => state.branch?.currentBranch
  // );
  // TODO: implement branch filtering for pos
  const { data } = useGetOrderbyId(orderId || "");

  console.log("Data: ", data);
  // const totalItems = cart.reduce((acc, item) => acc + item.quantity, 0);
  // const totalPrice = cart.reduce(
  //   (acc, item) => acc + item.price * item.quantity,
  //   0
  // );
  // TODO: don't allow users to order more than the quantity of products available when sell_oos is false
  // TODO: make sure the maximum number of products a user can sell is the maximum number available if sell_oos is true

  // const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedBranch, setSelectedBranch] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSupplier, setSelectedSupplier] = useState("");
  const [activeTab, setActiveTab] = useState<string>("1");
  const [isAddCustomerModalOpen, setIsAddCustomerModalOpen] = useState(false);
  const { data: productList = [], isLoading: productsLoading } =
    useGetProducts(selectedBranchID);
  const { data: branches } = useGetBranches();
  const { data: categories } = useGetCategories();
  const { data: suppliers } = useGetSuppliers();
  const { data: customers } = useGetCustomers();

  const addToCart = (id: string) => {
    const product = productList.find((product) => product.id.toString() === id);
    if (!product) return;

    const cartItem: CartItem = {
      id,
      quantity: 1,
      name: product.name,
      price: product.selling_price,
      imageUrl: product?.images?.[0]?.url || productPlaceholder,
      product: product,
      discount_amt: 0,
      discount_percentage: 0,
    };

    dispatch(addItem(cartItem));
  };

  const removeFromCart = (id: string) => {
    dispatch(removeItem(id));
  };

  const customerId = useSelector((state: RootState) => state.cart.customer_id);

  const filteredProducts = productList
    ? productList.filter((product) => {
        const matchesSearchQuery = product.name
          .toLowerCase()
          .includes(searchQuery.toLowerCase());
        const matchesBranch = selectedBranch
          ? product.branch_id.toString() === selectedBranch
          : true;
        const matchesCategory = selectedCategory
          ? product.category_id.toString() === selectedCategory
          : true;
        const matchesSupplier = selectedSupplier
          ? product.supplier_id.toString() === selectedSupplier
          : true;

        return (
          matchesSearchQuery &&
          matchesBranch &&
          matchesCategory &&
          matchesSupplier
        );
      })
    : [];

  // Function to clear all filters
  const clearFilters = () => {
    setSelectedBranch("");
    setSelectedCategory("");
    setSelectedSupplier("");
  };

  useEffect(() => {
    if (orderId) {
      if (data && data.order_items) {
        dispatch(clearCart());
        dispatch(setCustomerId(data.customer.id));
        data.order_items.forEach((item: CartItem) => {
          const payload = {
            id: item.product.id.toString(),
            quantity: item.quantity,
            name: item.product.name,
            price: item.price,
            product: item.product,
            discount_amt: item?.discount_amt | 0,
            discount_percentage: item?.discount_percentage | 0,
          };
          dispatch(addItem(payload));
        });
      }
    }

    return () => {
      dispatch(clearCustomerId());
      dispatch(clearOrderId());
      // if (orderId) {
      // dispatch(clearCart());
    };
  }, [data, orderId]);

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="px-md-2 px-xl-3 h-100">
          <Breadcrumbs title="Point of Sale" breadcrumbItem="POS" />

          {/* Search and Filter Button */}
          <Row>
            <Col lg={12}>
              <Row className="mb-2 align-items-center">
                <Col xs={12} md={10}>
                  <BaseInput
                    // label="Search Products"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search products..."
                    className="mb-0"
                    style={{ paddingRight: "10px" }}
                  />
                </Col>
              </Row>
              {/* Filters */}

              {/* Branch Filter */}
              <Row className="align-items-center mb-2">
                <Col xs={12} md="auto" className="mb-2 mb-md-0">
                  <Input
                    type="select"
                    value={selectedBranch}
                    onChange={(e) => setSelectedBranch(e.target.value)}
                  >
                    <option value="">All Branches</option>
                    {branches &&
                      branches.map((branch) => (
                        <option key={branch.id} value={branch.id}>
                          {branch.name}
                        </option>
                      ))}
                  </Input>
                </Col>

                {/* Category Filter */}
                <Col xs={12} md="auto" className="mb-2 mb-md-0">
                  <Input
                    type="select"
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value)}
                  >
                    <option value="">All Categories</option>
                    {categories &&
                      categories.map((category) => (
                        <option key={category.id} value={category.id}>
                          {category.name}
                        </option>
                      ))}
                  </Input>
                </Col>

                {/* Supplier Filter */}
                <Col xs={12} md="auto" className="mb-2 mb-md-0">
                  <Input
                    type="select"
                    value={selectedSupplier}
                    onChange={(e) => setSelectedSupplier(e.target.value)}
                  >
                    <option value="">All Suppliers</option>
                    {suppliers &&
                      suppliers.map((supplier) => (
                        <option key={supplier.id} value={supplier.id}>
                          {supplier.name}
                        </option>
                      ))}
                  </Input>
                </Col>

                {/* Clear Filters Button */}
                <Col xs={12} md="auto" className="mb-2 mb-md-0">
                  <Button color="secondary" onClick={clearFilters}>
                    Clear Filters
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
          {productsLoading ? (
            <div
              className="d-flex justify-content-center"
              style={{ height: "calc(100vh - 200px)" }}
            >
              <Spinner />
            </div>
          ) : (
            <Row className="mt-2">
              <Col md={12} lg={6}>
                <SimpleBar
                  className="mx-0 px-0"
                  style={{
                    height: "calc(100vh - 200px)",
                    overflowX: "hidden",
                    overflowY: "auto",
                  }}
                >
                  <Row className="mb-3">
                    {!isEmpty(filteredProducts) &&
                      filteredProducts.map((product: Product, key: number) => (
                        <ProductCard
                          key={product.id.toString()}
                          product={{
                            ...product,
                            id: product.id.toString(),
                            quantity: product.quantity || 0,
                          }}
                          cart={cart}
                          addToCart={addToCart}
                          removeFromCart={removeFromCart}
                        />
                      ))}
                  </Row>
                </SimpleBar>
              </Col>
              <Col md={12} lg={6}>
                <div className="checkout-tabs">
                  <Row>
                    <Col>
                      <Card className="shadow-none p-0">
                        <CardBody className="p-0">
                          {cart.length > 0 && (
                            <Row className="px-4 pt-4 justify-content-between">
                              <Col sm={6}>
                                <Input
                                  type="select"
                                  className="mb-3"
                                  placeholder="Select Customer"
                                  value={customerId}
                                  onChange={(e) =>
                                    dispatch(setCustomerId(e.target.value))
                                  }
                                >
                                  <option value="">Select Customer</option>
                                  {customers &&
                                    customers.map((customer) => (
                                      <option
                                        key={customer.id}
                                        value={customer.id}
                                      >
                                        {customer.name}
                                      </option>
                                    ))}
                                </Input>
                              </Col>
                              <Col sm={6}>
                                <div className="text-sm-end">
                                  <Button
                                    color="primary"
                                    onClick={() =>
                                      setIsAddCustomerModalOpen(true)
                                    }
                                  >
                                    Add Customer
                                  </Button>
                                </div>
                              </Col>
                            </Row>
                          )}
                          <TabContent activeTab={activeTab} className="mt-0">
                            <TabPane tabId="1">
                              <CartItems
                                cart={cart}
                                setActiveTab={setActiveTab}
                              />
                            </TabPane>
                            {/* Payment Info */}
                            <TabPane tabId="2">
                              <PaymentForm
                                payment_method_id={data?.payment_method?.id}
                                setActiveTab={setActiveTab}
                              />
                            </TabPane>

                            {/* Confirmation Details */}
                            <TabPane tabId="3">
                              <ConfirmationDetails
                                order={data}
                                setActiveTab={setActiveTab}
                              />
                            </TabPane>
                          </TabContent>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          )}
        </div>
      </div>
      <AddCustomerModal
        isOpen={isAddCustomerModalOpen}
        toggle={() => setIsAddCustomerModalOpen(!isAddCustomerModalOpen)}
      />
    </React.Fragment>
  );
}

export default withRouter(POSPage);
